<template>
	<div class="new_talents">
		<div v-wechat-title="$route.meta.title"></div>
		<TopBar></TopBar>
		<div class="flex_box">
			<div style="height: 60px;" class="flex_div">
				新增人才信息
			</div>
			<div class="flex_div">
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<div class="title_css">个人信息</div>
					<Button class="btn_css" type="primary" v-if="userInfo.menuList.homePage.talentPool_saveTalent" @click="saveTalentBaseInfo">保存(个人信息)</Button>
				</div>
				<Form :model="talentInfo">
					<div class="margin_top_css">
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">姓名</div>
									<Input v-model="talentInfo.name" placeholder="请输入姓名" style="width: 200px" />
									<span style="font-size: 12px; color: #919393; margin: 0 5px;">重点关注</span>
									<i-switch v-model="talentInfo.special" />
								</div>
							</FormItem>
						</div>
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">毕业时间</div>
									<DatePicker @on-change="talentInfo.graduateTime=$event" :value="talentInfo.graduateTime" format="yyyy-MM-dd" type="date" placeholder="请选择毕业时间" style="width: 300px"></DatePicker>
								</div>
							</FormItem>
						</div>
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">性别</div>
									<Select v-model="talentInfo.sex" style="width:300px">
										<Option v-for="item in sexList" :value="item.value" :key="item.value">{{ item.label }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">应聘岗位</div>
									<Select v-model="talentInfo.position" style="width:300px">
										<Option v-for="item in positionList" :value="item.id" :key="item.id">{{ item.position_name }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">出生年月</div>
									<DatePicker @on-change="talentInfo.birthday=$event" :value="talentInfo.birthday" format="yyyy-MM-dd" type="date" placeholder="请选择出生年月" style="width: 200px"></DatePicker>
									<div style="margin-left: 5px;">年龄：</div>
									<div>{{getAgeByBirth(talentInfo.birthday)}}</div>
								</div>
							</FormItem>
						</div>
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">电话</div>
									<Input v-model="talentInfo.phone" placeholder="请输入电话" style="width: 300px" />
								</div>
							</FormItem>
						</div>
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">申请时间</div>
									<DatePicker type="date" @on-change="talentInfo.applyTime=$event" :value="talentInfo.applyTime" format="yyyy-MM-dd" placeholder="请选择申请时间" style="width: 300px"></DatePicker>
								</div>
							</FormItem>
						</div>
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">通过司考</div>
									<Select v-model="talentInfo.nbeStatus" style="width:300px">
										<Option v-for="item in nbeStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						<div style="width: 650px;">
							<FormItem>
								<div style="display: flex;">
									<div class="title_width">学历</div>
									<div style="display: flex;flex-direction: column; margin-top: -5px;">
										<Select v-for="(item,index) in talentInfo.education" :key="index" v-model="talentInfo.education[index]" style="width:300px;margin: 5px 0;">
											<Option v-for="item in educationList" :value="item.label" :key="item.value">{{ item.label }}</Option>
										</Select>
										<span @click="addEducationClick" style="color: #0092FF; cursor: pointer;">添加学历</span>
									</div>
								</div>
							</FormItem>
						</div>

						<div style="width: 650px;">
							<FormItem>
								<div style="display: flex;">
									<div class="title_width">毕业院校</div>
									<div style="display: flex;flex-direction: column; margin-top: -5px;">
										<div v-for="(item,index) in talentInfo.school" :key="index">
											<Input v-model="talentInfo.school[index]" placeholder="请输入毕业院校" style="width: 300px;margin: 5px 0;" />
											<span v-if="index > 0" @click="subtractClick" :data-index="index" style="margin-left: 10px; color: #0092FF; cursor: pointer;"
											 class="icon iconfont icon-jian"></span>
										</div>
									</div>
								</div>
							</FormItem>
						</div>

					</div>
				</Form>
			</div>
			<!-- 附件简历 -->
			<div class="flex_div">
				<div class="title_css" style="margin-bottom: 15px;">附件简历</div>
				<Upload action="https://tp.likuan.tech/app/api/uploadFile" :before-upload="beforeUpload" :on-success="uploadResume" :format="['docx','pdf']" :on-format-error="handleFormatError" :default-file-list="resumeInfo" :on-remove="removeResume">
					<Button icon="ios-cloud-upload-outline">添加</Button>
				</Upload>
			</div>
			<!-- 初筛 -->
			<div class="flex_div">
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<div class="title_css">初筛</div>
					<Button class="btn_css" type="primary" v-if="userInfo.menuList.homePage.talentPool_saveTalent" @click="savefirstFiltrate">保存</Button>
				</div>
				<Form :model="firstFiltrate">
					<div class="margin_top_css">
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">面试官</div>
									<Select v-model="firstFiltrate.interviewer" style="width:300px">
                                        <Option v-for="(interviewer,index) in interviewerList" :value="interviewer.id" :key="index">{{ interviewer.name }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div style="display: flex; margin-top: 25px;">
									<div class="title_width">意见</div>
									<Input v-model="firstFiltrate.feedback" style="width: 300px;margin-top: 7px;" type="textarea" :rows="3"  />
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">状态</div>
									<Select v-model="firstFiltrate.status" style="width:300px" >
                                        <Option v-for="(status,key) in statusList" :value="status.statusKey"  :key="key">{{ status.status }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
					</div>
				</Form>
			</div>

			<!-- 一面 -->
			<div class="flex_div" style="position: relative;">
				<div class="shade" v-if="firstShade"></div>
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<div class="title_css">一面</div>
					<Button class="btn_css" type="primary" v-if="userInfo.menuList.homePage.talentPool_saveTalent" @click="saveFirstInterview">保存</Button>
				</div>
				<Form :model="firstInterview">
					<div class="margin_top_css">
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">是否参加</div>
									<Select v-model="firstInterview.attend" style="width:300px">
										<Option v-for="item in okOrNoList" :value="item.value" :key="item.value">{{ item.label }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>

						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">预约时间</div>
									<DatePicker  @on-change="firstInterview.appointedTime.date=$event" :value="firstInterview.appointedTime.date" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 150px"></DatePicker>
									<TimePicker v-model="firstInterview.appointedTime.time" type="time" placeholder="选择时间" style="width: 100px; margin-left: 50px;"></TimePicker>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">面试方式</div>
                                    <Input v-model="firstInterview.way" placeholder="请输入面试方式" style="width: 300px" />
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">到场时间</div>
									<DatePicker @on-change="firstInterview.bePresent.date=$event" :value="firstInterview.bePresent.date" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 150px"></DatePicker>
									<TimePicker v-model="firstInterview.bePresent.time" type="time" placeholder="选择时间" style="width: 100px; margin-left: 50px;"></TimePicker>
								</div>
							</FormItem>
						</div>
					  
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">面试官</div>
									<Select v-model="firstInterview.interviewer" style="width:300px">
                                        <Option v-for="(interviewer,index) in interviewerList" :value="interviewer.id" :key="index">{{ interviewer.name }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div style="display: flex; margin-top: 30px;">
									<div class="title_width">意见</div>
									<Input v-model="firstInterview.feedback" style="width: 300px;margin-top: 7px;" type="textarea" :rows="3"  />
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list" style="width: 1000px;">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">笔试分数</div>
									<Input v-model="firstInterview.grade" placeholder="请输入笔试分数" style="width: 300px;"  />
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">状态</div>
									<Select v-model="firstInterview.status" style="width:300px">
										<Option v-for="(status,key) in statusList" :value="status.statusKey" :key="key">{{ status.status }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						
					</div>
				</Form>
			</div>
			
			<!-- 二面 -->
			
			<div class="flex_div" style="margin-bottom: 50px; position: relative;">
				<div class="shade" v-if="secondShade"></div>
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<div class="title_css">二面</div>
					<Button class="btn_css" type="primary" v-if="userInfo.menuList.homePage.talentPool_saveTalent" @click="saveSecondInterview">保存</Button>
				</div>
				<Form :model="secondInterview">
					<div class="margin_top_css">
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">是否参加</div>
									<Select v-model="secondInterview.attend" style="width:300px">
										<Option v-for="item in okOrNoList" :value="item.value" :key="item.value">{{ item.label }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">预约时间</div>
									<DatePicker @on-change="secondInterview.appointedTime.date=$event" :value="secondInterview.appointedTime.date" format="yyyy-MM-dd" type="date" placeholder="选择日期" value="yyyy-mm-dd" style="width: 150px"></DatePicker>
									<TimePicker v-model="secondInterview.appointedTime.time" type="time" placeholder="选择时间" style="width: 100px; margin-left: 50px;"></TimePicker>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">面试方式</div>
                                     <Input v-model="secondInterview.way" placeholder="请输入面试方式" style="width: 300px" />
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">到场时间</div>
									<DatePicker @on-change="secondInterview.bePresent.date=$event" :value="secondInterview.bePresent.date" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 150px"></DatePicker>
									<TimePicker v-model="secondInterview.bePresent.time" type="time" placeholder="选择时间" style="width: 100px; margin-left: 50px;"></TimePicker>
								</div>
							</FormItem>
						</div>
					  
						<div class="flex_form_list">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">面试官</div>
									<Select v-model="secondInterview.interviewer" style="width:300px">
										<Option v-for="(interviewer,index) in interviewerList" :value="interviewer.id" :key="index">{{ interviewer.name }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list">
							<FormItem>
								<div style="display: flex; margin-top: 30px;">
									<div class="title_width">意见</div>
									<Input v-model="secondInterview.feedback" style="width: 300px;margin-top: 7px;" type="textarea" :rows="3"  />
								</div>
							</FormItem>
						</div>
						

						<div class="flex_form_list" style="width: 1000px;">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">状态</div>
									<Select v-model="secondInterview.status" style="width:300px">
										<Option v-for="(status,key) in statusList" :value="status.statusKey" :key="key">{{ status.status }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list" style="width: 1000px;">
							<FormItem>
								<div class="flex_item">
									<div class="title_width">计划到岗时间</div>
									<DatePicker @on-change="secondInterview.workTime=$event" :value="secondInterview.workTime" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 200px"></DatePicker>
								</div>
							</FormItem>
						</div>
						
						<div class="flex_form_list" >
							<FormItem>
								<div class="flex_item">
									<div class="title_width">是否入职</div>
									<Select v-model="secondInterview.entry" style="width:200px">
										<Option v-for="item in okOrNoList" :value="item.value" :key="item.value">{{ item.label }}</Option>
									</Select>
								</div>
							</FormItem>
						</div>
						
					</div>
				</Form>
			</div>
			
		</div>

	</div>
</template>

<script>
    import {mapGetters} from 'vuex';
	import TopBar from '../topbar/TopBar.vue';
	import moment from 'moment';
    
    import {
        getUserList
        }from '@/api/user.js';
    import {
            getAllPositionInfo,saveTalentBaseInfo,saveUploadResumeInfo,savefirstFiltrateInfo,getTalentInfoByTalentId,saveFirstInterview,saveSecondInterview
        }from '@/api/talent.js';
	export default {
		name: "NewTalents",
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
		components: {
			TopBar
		},
        mounted: function () {
        	this.getInterviewerList();
            this.getAllPositionInfo();
            this.talentInfo.talentId = parseInt(this.$route.query.id);
            this.getTalentInfoByTalentId();
        },
		data() {
			return {
                firstShade:true,
                secondShade:true,
				talentInfo: {
                    talentId:'',
					name: '',
					special: false,//重点关注
					graduateTime: '', //毕业时间
                    position:'',//应聘岗位
					sex: '',//性别
					birthday: '',//出生日期
                    age:'',//年龄
					phone: '',//电话号码
					applyTime: '',//申请时间
					nbeStatus: '',//司法考试状态
					education: ['', ''], //学历
					school: ['', ''], //毕业院校
				},
                //简历上传
                resumeInfo:[],
                //defaultResum:{},//默认显示已上传的简历
				// 初筛
				firstFiltrate:{
					interviewer:'',//面试官
                    status: -1,
                    feedback:'' //初试反馈
                    
				},
				interviewerList:{},// 面试官列表
                statusList:[//状态列表
                {
                   statusKey:-1,
                   status:'未进行'
                },
                  {
                     statusKey:0,
                     status:'未通过'
                  },
                  {
                    statusKey:1,
                    status:'已通过'
                  },
                  {
                    statusKey:2,
                    status:'未参加'
                  }
                ],    
				// 一面
				firstInterview:{
					attend:'',//是否参加
					appointedTime:{date:'',time:''},//预约时间
					way:'',//面试方式
					bePresent:{date:'',time:''},//到场时间
					interviewer:'',//面试官
					feedback:'',//一面意见
					grade:'',//分数
					status:''//一面状态
				},
				// 二面
				secondInterview:{
					attend:'',//是否参见
					appointedTime:{date:'',time:''},//预约时间
					way:'',//面试方式
					bePresent:{date:'',time:''},//到场时间
					interviewer:'',//面试官
					feedback:'',//意见
					status:'',//状态
					workTime:'',//计划到岗是时间
					entry:''//是否入职
				},
				//wayList:[],   //面试方式列表
				okOrNoList:[
					{
						value: '1',
						label: '是'
					},
					{
						value: '0',
						label: '否'
					},
				],
				sexList: [{
						value: 1,
						label: '男'
					},
					{
						value: 2,
						label: '女'
					},
				],
				positionList: [],
				nbeStatus: [{
						value: 1,
						label: '是'
					},
					{
						value: 0,
						label: '否'
					},
				],
				educationList: [{
						value: '大专',
						label: '大专'
					},
					{
						value: '本科',
						label: '本科'
					},
					{
						value: '研究生',
						label: '研究生'
					},
					{
						value: '博士生',
						label: '博士生'
					},
				]
			}
		},
		methods: {
			getAgeByBirth(e) {
				let day = moment().diff(moment(e), 'years')

				if (day >= 0) {
                    this.talentInfo.age = day;
					return day + '岁'
				}
			},
            //获取面试官列表
            async getInterviewerList(){
                let that = this
                let data = {token:that.token};
				let res = await getUserList(that, data);
				that.interviewerList = res.data.list
            },
            //获取岗位列表
            getAllPositionInfo(){
                let that = this
                let data = {token:this.token}

                getAllPositionInfo(data).then(function(res){
                    that.positionList = res.data.data
                });
            },
			// 添加学历
			addEducationClick() {
				this.talentInfo.education.push('')
				this.talentInfo.school.push('')
			},
            //保存人才基本信息
            saveTalentBaseInfo(){
               let that = this
               let data = {token:that.token,talentBaseInfo:that.talentInfo}


               saveTalentBaseInfo(data).then(function(res){
                   that.talentInfo.talentId = res.data.data
                   that.$Message.success('保存成功');
               }); 
            },
            //简历格式验证
            handleFormatError(file){
                this.$Notice.warning({
                    title: '仅支持docx,pdf格式文件',
                    desc: '文件 [' + file.name + '] 格式错误.'
                });
            },
            //上传之前验证
            beforeUpload(){

                if(this.talentInfo.talentId){
                    if(this.resumeInfo.length > 0){
                        this.$Notice.warning({
                            title: '超出最大文件上传数',
                            desc: '最多只能上传1个文件.'
                        });
                        return false;
                    }
                }else{
                    this.$Notice.warning({
                        title: '请先保存个人信息',
                        desc: '请先保存个人信息.'
                    });
                    return false;
                }
                return true;
            },
            //上传简历
            uploadResume(res,file,fileList){
                let that = this
                that.resumeInfo = fileList

                let data = {token:that.token, talentId:that.talentInfo.talentId, resumeInfo:that.resumeInfo}
                //保存上传的简历信息
                saveUploadResumeInfo(data).then(function(res){
                    if(res.status == 200){
                        that.$Notice.success({
                            title: '文件上传成功',
                            desc: res.data.msg
                        });
                    }else{
                        that.$Notice.warning({
                            title: '文件上传失败',
                            desc: res.data.msg
                        });
                    }
                });
            },
            //删除简历
            removeResume(file,fileList){
                let that = this
                that.resumeInfo = fileList
                let data = {token:that.token, talentId:that.talentInfo.talentId, resumeInfo:that.resumeInfo}

                saveUploadResumeInfo(data).then(function(res){
                    if(res.status == 200){
                        that.$Notice.success({
                            title: '删除成功',
                            desc: '文件删除成功'
                        });
                    }else{
                        that.$Notice.warning({
                            title: '删除失败',
                            desc: '文件删除失败'
                        });
                    }
                });
            },
            //保存初筛信息
            savefirstFiltrate(){
                let that = this
                if(this.talentInfo.talentId){
                    let data = {token:that.token, talentId:that.talentInfo.talentId, firstFiltrateInfo:that.firstFiltrate}
                    
                    savefirstFiltrateInfo(data).then(function (res){
                        if(res.status == 200){
                            if(that.firstFiltrate.status == 1){
                                //初筛已过，一面信息可编辑
                                that.firstShade = false
                            }else{
                                that.firstShade = true
                            }
                            that.$Message.success(res.data.msg);
                        }else{
                            that.$Message.warning(res.data.msg);
                        }
                    });
                }else{
                    that.$Message.warning('请先保存个人信息');
                    return false;
                }
            },
            //保存一面信息
            saveFirstInterview(){
                let that = this
                let data = {token:this.token, talentId:that.talentInfo.talentId, firstInterviewInfo:that.firstInterview}

                saveFirstInterview(data).then(function (res){
                    
                    if(res.status == 200){
                        if(that.firstInterview.status == 1){
                            //初筛已过，一面信息可编辑
                            that.secondShade = false
                        }else{
                            that.secondShade = true
                        }
                        that.$Message.success(res.data.msg);
                    }else{
                        that.$Message.warning(res.data.msg);
                    }
                });
            },
            
            //保存二面信息
            saveSecondInterview(){
                let that = this
                let data = {token:that.token, talentId:that.talentInfo.talentId, secondInterviewInfo:that.secondInterview}
                saveSecondInterview(data).then(function (res){
                    if(res.status == 200){
                        that.$Message.success(res.data.msg);
                    }else{
                        that.$Message.warning(res.data.msg);
                    }
                });
            },
			// 减少学历
			subtractClick(e) {
				let index = e.currentTarget.dataset.index
				this.talentInfo.education.splice(index, 1)
				this.talentInfo.school.splice(index, 1)
			},
            //获取具体人才的信息
            getTalentInfoByTalentId(){
                let that = this
                let data = {token:that.token, talentId:that.talentInfo.talentId}
                if(that.talentInfo.talentId){
                    getTalentInfoByTalentId(data).then(function (res){
                        
                        //基础信息
                        that.talentInfo = res.data.data.baseInfo
                        //已上传简历信息
                        if(res.data.data.resumeInfo){
                            that.resumeInfo.push(res.data.data.resumeInfo);
                        }
                        
                        //初筛信息
                        that.firstFiltrate = res.data.data.firstFiltrate
                        if(that.firstFiltrate.status == 1){
                            //初筛已过，一面信息可编辑
                            that.firstShade = false
                        }else{
                            that.firstShade = true
                        }

                        //一面信息
                        if(res.data.data.firstInterview){
                            that.firstInterview = res.data.data.firstInterview
                            if(that.firstInterview.status == 1){
                                //一面通过，二面信息可编辑上
                                that.secondShade = false
                            }else{
                                that.secondShade = true
                            }
                        }

                        //二面信息
                        if(res.data.data.secondInterview){
                            that.secondInterview = res.data.data.secondInterview
                        }
                    });
                }
                
            }
		},

	}
</script>

<style scoped lang="less">
	.new_talents {
		width: 100%;
		background-color: #F5F7F9;
	}

	.flex_box {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.flex_div {
		width: 85%;
		background-color: #FFFFFF;
		margin-top: 20px;
		padding: 20px;
		border-radius: 10px;
	}

	.title_css {
		font-size: 18px;
		font-weight: bold;
	}

	.btn_css {
		border-radius: 30px;
	}

	.margin_top_css {
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.flex_form_list {
		display: flex;
		align-items: center;
		width: 650px;
		height: 48px;
	}

	.title_width {
		width: 60px;
		text-align-last: justify;
		color: #A6A4A2;
		margin-right: 15px;
	}

	.flex_item {
		display: flex;
		align-items: center;
	}
	.shade{
		width: 100%; height: 100%; background-color: rgba(0,0,0,0.1); position: absolute; z-index: 1; top: 0; border-radius: 10px; left: 0px;
	}
</style>
